export enum LANGUAGES {
  ENGLISH = 'English',
  SPANISH = 'Spanish',
}
